import { render, staticRenderFns } from "./paperSubmitType.vue?vue&type=template&id=2b40ffd4&scoped=true&"
import script from "./paperSubmitType.vue?vue&type=script&lang=js&"
export * from "./paperSubmitType.vue?vue&type=script&lang=js&"
import style0 from "./paperSubmitType.vue?vue&type=style&index=0&id=2b40ffd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b40ffd4",
  null
  
)

export default component.exports